module.exports = __webpack_public_path__ + "static/media/landing-tab-provider-management-m.bdd1a7e6.svg";